import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
} from '@mui/material';
import { FaArrowRight } from 'react-icons/fa';
import { Step, StepAnswers } from '../types';

interface AnswersSummaryProps {
  steps: Step[];
  answers: StepAnswers[];
  onBack: () => void;
  onShowResults: () => void;
}

export const AnswersSummary: React.FC<AnswersSummaryProps> = ({
  steps,
  answers,
  onBack,
  onShowResults,
}) => {
  return (
    <Box sx={{ my: 8 }}>
      <Typography variant="h4" gutterBottom color="primary">
        Assessment Summary
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
        Review your responses before seeing your career recommendations:
      </Typography>

      {steps.map((step, stepIndex) => (
        <Paper
          key={stepIndex}
          elevation={2}
          sx={{ p: 3, mb: 3, borderRadius: 2 }}
        >
          <Typography
            variant="h6"
            sx={{
              mb: 2,
              color: step.color,
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            <step.icon size={24} />
            {step.title}
          </Typography>

          {answers[stepIndex]?.answers.map((answer, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                {answer.question}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'text.secondary',
                  pl: 2,
                  borderLeft: '3px solid',
                  borderColor: step.color
                }}
              >
                {answer.answer.text}
              </Typography>
            </Box>
          ))}
        </Paper>
      ))}

      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          variant="outlined"
          onClick={onBack}
        >
          Back to Assessment
        </Button>
        <Button
          variant="contained"
          onClick={onShowResults}
          endIcon={<FaArrowRight />}
        >
          View Career Recommendations
        </Button>
      </Box>
    </Box>
  );
};
